import { render, staticRenderFns } from "./ImpersonateButton.vue?vue&type=template&id=7232a1e9"
import script from "./ImpersonateButton.vue?vue&type=script&lang=js"
export * from "./ImpersonateButton.vue?vue&type=script&lang=js"
import style0 from "./ImpersonateButton.vue?vue&type=style&index=0&id=7232a1e9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports